import React, { useState } from 'react';
import cx from 'classnames';
import { AsyncState } from 'react-async';
import DOMPurify from 'dompurify';

type ResponseStatusProps = {
  successMessage?: string;
  state: AsyncState<any>;
};

type NotificationProps = {
  message?: string;
  children?: React.ReactNode;
  isSuccess?: boolean;
  isOpen?: boolean;
  isUserCloseable?: boolean;
  onClose?: () => void;
};

export const Notification = ({
  message,
  children,
  isSuccess = true,
  isOpen = true,
  isUserCloseable = true,
  onClose,
}: NotificationProps) => {
  const [open, setOpen] = useState(isOpen);
  const sanitizemsg = DOMPurify.sanitize(message as any)

  const handleClose = () => {
    setOpen(false);

    if (onClose) {
      onClose();
    }
  };

  return (
    <div
      className={cx(
        'justify-between text-base text-gray-50 p-3 rounded-lg shadow mb-6 items-center',
        open ? 'flex' : 'hidden',
        isSuccess ? 'bg-ptsgreen-normal' : 'bg-red-500'
      )}
    >
      {children && <div>{children}</div>}
      {!children && (
        <div
          className='p-2'
          dangerouslySetInnerHTML={{ __html: sanitizemsg ?? '' }}
        />
      )}
      {isUserCloseable && (
        <button
          className='py-2 px-0 bg-transparent hover:bg-transparent'
          onClick={handleClose}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-6 w-6'
            viewBox='0 0 20 20'
            fill='currentColor'
          >
            <path
              fillRule='evenodd'
              d='M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z'
              clipRule='evenodd'
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export const ResponseStatus = ({
  successMessage = 'Your request was processed successfully!',
  state,
}: ResponseStatusProps) => {
  if (state.isRejected)
    return (
      <Notification
        isSuccess={false}
        isOpen={true}
        message={state.error.toString()}
      />
    );

  if (state.isResolved)
    return (
      <Notification isSuccess={true} isOpen={true} message={successMessage} />
    );

  return null;
};
